import Card from 'components/Card';
import Typography from 'components/Typography';
import {IntegrationOption} from 'types/integration';
import styles from '../IntegrationList/IntegrationList.module.scss';
import CardContent from 'components/CardContent';
import ButtonWithIcon from 'components/ButtonWithIcon';
import classNames from 'classnames';
import PlusIcon from 'pages/RouteHistory/icons/plus';
import {useState} from 'react';

type Props = {
  integration: IntegrationOption;
  isIntegrated: boolean;
  onConnect?: () => void;
  onDisconnect?: () => void;
  isConnecting?: boolean;
};

function IntegrationCard({
  integration,
  isIntegrated,
  onConnect,
  onDisconnect,
  isConnecting,
}: Props) {
  const {logo, company_name, description} = integration;

  const [isBadgeHovered, setIsBadgeHovered] = useState(false);
  return (
    <Card
      className={classNames(
        styles.integrationCard,
        isIntegrated && styles.integratedCard
      )}
    >
      <CardContent className={styles.cardContent}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.logo}>{logo}</div>
            <div className={styles.titleContainer}>
              <Typography variant="h3" className={styles.companyName}>
                {company_name}
              </Typography>
              {isIntegrated && (
                <div className={styles.statusBadge}>
                  <div
                    className={styles.interactiveBadge}
                    onMouseEnter={() => setIsBadgeHovered(true)}
                    onMouseLeave={() => setIsBadgeHovered(false)}
                    onClick={onDisconnect}
                  >
                    {isBadgeHovered ? 'Disconnect' : 'Connected'}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.content}>
          <Typography variant="label" className={styles.description}>
            {description}
          </Typography>
        </div>

        <div className={styles.actions}>
          {!isIntegrated && (
            <ButtonWithIcon
              color={'green-outlined'}
              size="md"
              icon={<PlusIcon width={16} height={16} />}
              onClick={onConnect}
              disabled={isConnecting}
              loading={isConnecting}
            >
              Connect
            </ButtonWithIcon>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
export default IntegrationCard;
